module.exports = {
  pixels:
    [
      {
        name: 'Google Analytics',
        key: 'GOOGLE_ANALYTICS',
        icon: 'googleAnalytics',
        placeholder: 'Please enter your tracking pixel code'
      },
      {
        name: 'Google Tag Manager',
        key: 'GOOGLE_TAG_MANAGER',
        icon: 'googleTagManager',
        placeholder: 'Please enter your tracking pixel code'
      },
      {
        name: 'Facebook',
        key: 'FACEBOOK',
        icon: 'facebook',
        placeholder: 'Please enter your tracking pixel code'
      },
      {
        name: 'LinkedIn',
        key: 'LINKEDIN',
        icon: 'linkedIn',
        placeholder: 'Please enter your tracking pixel code'
      },
      {
        name: 'Munchkin',
        key: 'MUNCHKIN',
        icon: 'munchkin',
        placeholder: 'Please enter your tracking pixel code'
      },
      {
        name: '6Sense',
        key: 'SIXSENSE',
        icon: 'sixSense',
        placeholder: 'Please enter your tracking pixel code'
      }
    ]
};